import script from "./ResultSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultSummary.vue?vue&type=script&setup=true&lang=js"

import "./ResultSummary.vue?vue&type=style&index=0&id=48f771b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48f771b0"]])

export default __exports__